import React from 'react';
import styled, { keyframes } from 'styled-components';
import { shake } from 'react-animations';

import { Button } from 'rmwc/Button';
import Sizes from '../Assets/Sizes';
import { performIfDelegate } from "@tomeravni/easybizy-js-common/common";

const fadeInAnimation = keyframes`${ shake }`;
const anim = `1s ${ fadeInAnimation }`;

const Container = styled.div`
  position: relative;
  padding: 1em;
  overflow-y: ${ p => p.flow ? 'visible' : 'hidden' };
  overflow-x: hidden;

`;

export const NavigationBottomButton = styled(Button)`
  opacity: ${ props => props.disabled ? 0.3 : 1 };
  animation: ${ props => props.loading === 'true' ? 'pulse 1.5s infinite;' : ((!props.disabled && !props.preventAnimation) ? anim : undefined) };
  animation-delay: 1s;


  &.has-left-text {
    display: flex;
    justify-content: space-between;
    padding-left: ${ Sizes.defaultPadding };
    padding-right: ${ Sizes.defaultPadding };

    div {
      font-size: ${ Sizes.navigationButtonTextSize };
      font-weight: bold;
    }
  }

  &.mdc-button:disabled, &.mdc-button:not(:disabled) {
    font-family: inherit;
    font-weight: bold;
    background-color: ${ p => p.theme.properties.outlinedPrimary ? 'transparent' : p.theme.colors.surfaceTop };
    color: ${ props => props.theme.colors.surfaceBottomInverted };
    width: 100%;
    font-size: 16px;
    min-height: ${ Sizes.actionButtonHeight };
    border: 2px solid ${ p => p.theme.properties.outlinedPrimary ? p.theme.colors.primaryText : 'transparent' };
  }

  span {
    transition: color 0.2s ease-out;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
`;

const ButtonMaskBackground = styled.div`
  background-color: ${ p => p.theme.colors.primary };
  width: 100%;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
  transform: translateY(${ props => props.disabled ? '100%' : '0' });

`;

const ButtonDisabledButton = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const CenterDiv = styled.div`
  margin: ${ prop => prop.center ? '0 auto' : '0' };
`;

const NavigationButton = (props) => {
	return <Container { ...props } className="page__navigation-button">
		<ButtonDisabledButton onClick={ () => props.disabled && performIfDelegate(props.onDisabledClicked) }/>
		<ButtonMaskBackground disabled={ props.disabled }/>
		<NavigationBottomButton disabled={ props.disabled } onClick={ () => performIfDelegate(props.click) }
								custom-theme="shallow-button"
								className={ props.leftText && 'has-left-text' }>
			<CenterDiv center={ !props.leftText }>{ props.children }</CenterDiv>
		</NavigationBottomButton></Container>;
};

export default NavigationButton;

